import './checkoutWithPaypalSdkButton.scss';

import { PaypalSdkService } from './../../services/paypalSdk.service';

export const CheckoutWithPaypalSdkButton = angular
    .module('checkout.components.checkoutWithPaypalSdkButton', [PaypalSdkService])
    .component('checkoutWithPaypalSdkButton', {
        template: '<div id="paypal-sdk-button-container"></div>',
        bindings: {
            cartId: '<',
            bagId: '<',
            getGiftCards: '<'
        },
        controller: class PaypalButtonCtrl {
            constructor(paypalSdkService) {
                angular.extend(this, { paypalSdkService });
            }
            $onInit() {
                this.paypalSdkService.renderPaypalButtons(
                    this.cartId,
                    this.bagId,
                    this.getGiftCards
                );
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/checkoutWithPaypalSdkButton/checkoutWithPaypalSdkButton.js